module.exports = __webpack_public_path__ + "img/curve_line_2_icon.aed47a8a.svg";